import { render } from "./NewWarehouse.vue?vue&type=template&id=332ec2cb&scoped=true&ts=true"
import script from "./NewWarehouse.vue?vue&type=script&lang=ts"
export * from "./NewWarehouse.vue?vue&type=script&lang=ts"

import "./NewWarehouse.vue?vue&type=style&index=0&id=332ec2cb&lang=scss&scoped=true"
import "./NewWarehouse.vue?vue&type=style&index=1&id=332ec2cb&lang=css"

import exportComponent from "/var/jenkins_home/workspace/saas-fulfillment-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-332ec2cb"]])

export default __exports__